import React from 'react';
import { Text } from '@charlietango/ui';

import { CollectionState, collectionStateMap } from '../../api/api-types';
import { useDictionary } from '../../hooks/useDictionary';
import { useElectionType } from '../../hooks/useSearchParams';
import StatusIcon from '../../icons/StatusIcon';
import { colors } from '../../styles/colors';
import { FontWeight, TextVariant } from '../../styles/typography';
import { itemStyle } from './PartyDetailsItem';
import { rem } from '../../styles/rem';

type Props = {
  status?: CollectionState;
};

function Status({ status }: Props) {
  const { electionTypeValue } = useElectionType();
  const runningState = status === CollectionState.running;
  const { t } = useDictionary();
  if (status === undefined || electionTypeValue === undefined) return null;

  return (
    <div
      sx={{
        ...itemStyle,
        marginBottom: 0,
        backgroundColor: !runningState
          ? colors.components.notificationListItem.Background.Default
          : 'transparent',
        px: !runningState ? 5 : 0,
        py: !runningState ? 5 : 4,
        color: colors.base.Text.Primary,
      }}
    >
      {runningState ? (
        <>
          <Text
            as="dt"
            variant={TextVariant.BodyLg}
            sx={{ flex: '0 0 auto', mr: 4 }}
          >
            {t('party.state')}
          </Text>
          <Text as="dd">{t(`partyStatus.${collectionStateMap[status]}`)}</Text>
        </>
      ) : (
        <div sx={{ display: 'flex', alignItems: 'start' }}>
          <dt
            sx={{
              flex: '0 0 auto',
              mr: rem(32),
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <StatusIcon sx={{ mr: 3 }} />
            <Text
              as="span"
              variant={TextVariant.BodyMd}
              sx={{ fontWeight: FontWeight.Bold }}
            >
              {t('party.state')}
            </Text>
          </dt>
          <Text as="dd" sx={{ textAlign: 'left' }} variant={TextVariant.BodyMd}>
            {t(`partyStatus.${collectionStateMap[status]}`, {
              electionType: t(`${electionTypeValue}Election`),
            })}
          </Text>
        </div>
      )}
    </div>
  );
}

export default Status;
